<section class="floorplans" id="floorplans">

  <!-- Section header -->
  <div class="fp-header">
    <p class="section-label fp-label">The</p>
    <h2 class="fp-title">Floor Plans</h2>
    <div class="fp-rule"></div>
  </div>

  <!-- Primary tabs (floor levels) -->
  <nav class="fp-tabs-wrap" role="tablist" aria-label="Floor plan levels">
    @for (tab of tabs; track tab.id) {
      <button
        class="fp-tab"
        [class.active]="activeTabId === tab.id"
        role="tab"
        [attr.aria-selected]="activeTabId === tab.id"
        (click)="selectTab(tab.id)"
      >{{ tab.label }}</button>
    }
  </nav>

  <!-- Sub-tabs: shown only for grouped tabs (a/b/c variants) -->
  @if (hasVariants) {
    <div class="fp-subtabs-wrap" role="tablist" [attr.aria-label]="activeTab.label + ' variants'">
      @for (v of activeTab.variants; track v.id) {
        <button
          class="fp-subtab"
          [class.active]="activeVariantId === v.id"
          role="tab"
          [attr.aria-selected]="activeVariantId === v.id"
          (click)="activeVariantId = v.id"
        >{{ v.label }}</button>
      }
    </div>
  }

  <!-- Floor plan panel -->
  <div class="fp-panel" role="tabpanel">

    <!-- Dimension info card (bedroom tabs with size data) -->
    @if (activeVariant.size) {
      <div class="fp-info-card">
        <p class="fp-info-bed">{{ activeTab.label }}</p>
        <p class="fp-info-type">{{ activeVariant.label }}</p>
        <p class="fp-info-size">{{ activeVariant.size }}</p>
      </div>
    }

    <!-- Plan label card (floor level tabs) -->
    @if (activeTab.planLabel && !activeVariant.size) {
      <div class="fp-info-card fp-info-card--plan">
        @for (line of activeTab.planLabel!.split('\n'); track $index) {
          <p class="fp-info-planline">{{ line }}</p>
        }
      </div>
    }

    <div class="fp-image-wrap">
      <img
        [src]="activeVariant.image"
        [alt]="activeVariant.alt"
        class="fp-image"
        loading="lazy"
      />
    </div>

    <!-- Fallback caption for tabs with no label data -->
    @if (!activeVariant.size && !activeTab.planLabel) {
      <p class="fp-caption">{{ activeVariant.label }}</p>
    }
  </div>

  <!-- Silhouette marquee -->
  <div class="fp-wildlife">
    <div class="fp-wildlife-marquee" aria-hidden="true">
      <div class="fp-wildlife-track">
        <img src="/silhouette.png" alt="" class="fp-wildlife-image" />
        <img src="/silhouette.png" alt="" class="fp-wildlife-image" />
        <img src="/silhouette.png" alt="" class="fp-wildlife-image" />
        <img src="/silhouette.png" alt="" class="fp-wildlife-image" />
      </div>
    </div>
  </div>

</section>
